import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const QuestionIcon: FC<IconProps> = ({ width = 21, height = 15, ...rest }) => (
  <Icon type="QuestionIcon" width={width} height={height} alt="QuestionIcon" {...rest} />
)
